<template>
  <div class="trigger-the-setting details-view">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      style="min-height:100%"
    >
      <template slot="left">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :row-data="rowData"
          :column-defs="columnDefs"
          :show-side-bar="false"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          min-height="100%"
          :class="canSelectGrid"
          grid-style="min-width: 220px;width:100%;height:100%;"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div style="margin-left: 20px; margin-top: 20px;">
            <div style="width: 320px;margin-bottom: 30px;">
              <el-button v-if="!isEdit" type="primary" @click="toEdit">{{ $t('CargoMsg.Cargo_EditTo') }}</el-button>
              <el-button v-if="isEdit" type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
              <el-button v-if="isEdit" type="danger" @click="toCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            </div>
            <div>
              <el-checkbox v-model="form.configEnable" :disabled="!isEdit" :label="$t('AutomaticRelease.ApplyBranchOfficeSettings')" />
            </div>
            <div style="display: flex;">
              <div style="width: 340px; height: 100%; border-right: 2px solid #040404;">
                <div style="width: 320px;">
                  <el-row>
                    <el-col :span="12">
                      <div class="bordered-div">{{ $t('AutomaticRelease.TriggerTheNode') }}</div>
                    </el-col>
                    <el-col :span="12">
                      <div class="bordered-div">{{ $t('CargoMsg.Cargo_Enable') }}</div>
                    </el-col>
                  </el-row>
                  <div>
                    <el-checkbox-group v-model="form.setting" :disabled="!readonly">
                      <el-row v-for="item in releaseSettings" :key="item.code" style="width: 320px">
                        <el-col class="bordered-div" :span="12">
                          <div>{{ isZh ? item.chineseName : item.englishName }}</div>
                        </el-col>
                        <el-col class="bordered-div" :span="12">
                          <el-checkbox :label="item.code"><br></el-checkbox>
                        </el-col>
                      </el-row>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
              <div style="width: 340px; height: 100%; margin-left: 30px;">
                <el-checkbox v-model="form.autoEnable" :disabled="!readonly" :label="$t('AutomaticRelease.ScheduledPollingTriggersAutomaticOrderVerification')" />
                <div style="margin-top: 10px;">
                  <span style="margin-right: 5px;">{{ $t('AutomaticRelease.daily') }}</span>
                  <el-time-select
                    v-model="form.autoTime"
                    :disabled="!readonly"
                    :picker-options="pickerOptions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </cargo-left-right-resize></div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { cache, cacheName } from '@/utils/cacheManager'
import {
  queryAutomaticOrderReleaseSettings,
  queryReleaseDocConfig,
  saveReleaseDocConfig
} from '@/api/sysManage/baseConfig/putASingleRule'
import { deepClone } from '@/utils'
import * as commonUtil from '@/utils/commonUtil'
export default {
  name: 'TriggerTheSettings',
  components: { CargoLeftRightResize },
  data() {
    return {
      releaseSettings: [],
      rowData: [],
      isZh: this.$store.getters.language === 'zh',
      form: {
        configEnable: false,
        setting: [],
        autoEnable: false,
        autoTime: '00:00'
      },
      officeId: 0,
      tempForm: {
        configEnable: false,
        setting: [],
        autoEnable: false,
        autoTime: '00:00'
      },
      pickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      isEdit: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onCellClicked: async event => {
          this.onCellClicked(event)
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.CompanyName'),
          field: 'chineseName',
          suppressMenu: true,
          width: 180
        }
      ]
    }
  },
  computed: {
    readonly() {
      return this.isEdit && this.form.configEnable
    },
    canSelectGrid() {
      return this.isEdit ? 'no-edit section' : 'section'
    }
  },
  async mounted() {
    await cache.load(cacheName.OFFICE_LIST).then(() => {
      this.rowData = cache.officeList
    })
    this.loadConfig()
  },
  methods: {
    onCellClicked(event) {
      const data = event.data
      const officeId = data.officeId
      this.officeId = officeId
      this.loadOfficeConfig(officeId)
    },
    loadOfficeConfig(officeId) {
      // 获取
      queryReleaseDocConfig({ officeId: officeId }).then(res => {
        if (!res.data) {
          this.tempForm.officeId = officeId
          this.form = deepClone(this.tempForm)
        } else {
          const result = deepClone(res.data)
          result.setting = commonUtil.stringToNumArray(res.data.btnList)
          this.form = result
        }
      })
    },
    loadConfig() {
      queryAutomaticOrderReleaseSettings().then(res => {
        this.releaseSettings = res.data
      })
    },
    toEdit() {
      // 需要先选择分公司
      if (!this.officeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBranch'))
        return
      }
      this.isEdit = true
    },
    toSave() {
      this.form.btnList = this.form.setting.join(',')
      saveReleaseDocConfig(this.form).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        const result = deepClone(res.data)
        result.setting = commonUtil.stringToNumArray(res.data.btnList)
        this.form = result
        this.isEdit = false
      })
    },
    toCancel() {
      this.isEdit = false
      this.loadOfficeConfig(this.officeId)
    }
  }
}
</script>

<style lang="scss" scoped>
.trigger-the-setting{
  .bordered-div {
    border: 2px solid #000; /* 2像素宽的黑色实线边框 */
    padding: 10px; /* 可选：添加内边距以使内容不紧贴边框 */
    height: 34px;
    text-align: center;
  }
  .no-edit {
    pointer-events: none;
  }
}

</style>
